var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoAirtelKe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 4,
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_17064_351828",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_17064_351828)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.86 10.7564C21.5728 9.81725 21.0188 9.0451 20.2166 8.46339C20.1226 8.38466 19.1196 7.5585 17.2333 7.56399C15.5075 7.56912 13.6172 8.26152 11.6143 9.62638L11.5513 9.66988L11.5416 9.67537L11.3625 9.79206L11.2083 9.90055C10.7992 10.1884 10.4078 10.5001 10.044 10.8324C9.19876 11.6819 8.23566 13.0999 8.29993 14.3013C8.32652 14.8126 8.5335 15.2277 8.91511 15.5348C9.2586 15.8126 9.68807 15.9518 10.188 15.9499C11.2172 15.9463 12.342 15.3664 13.111 14.8757L13.2564 14.7723C13.3907 14.6817 13.5245 14.5887 13.6579 14.4944L13.7905 14.4034C14.883 13.6422 16.0145 12.855 17.2887 12.3932C17.6194 12.2737 17.9083 12.216 18.1752 12.2151C18.3068 12.2151 18.4349 12.2283 18.5581 12.2591C18.9459 12.3502 19.2313 12.5767 19.4015 12.9346C19.6994 13.5576 19.6316 14.5398 19.2313 15.44C18.6849 16.6672 17.7452 17.8768 16.4364 19.038C15.7721 19.6275 15.1547 20.0843 14.606 20.3951L14.5568 20.4222C14.3019 20.5686 14.0134 20.732 13.7098 20.8528L13.6681 20.869C13.5773 20.9041 13.5006 20.9362 13.431 20.96C12.604 21.1916 12.6177 20.793 12.7445 20.4767C12.8127 20.3037 13.0441 20.0048 13.3251 19.7009C13.4784 19.5402 13.6353 19.3883 13.7975 19.2308C13.9717 19.0633 14.1503 18.8908 14.3298 18.7013L14.3697 18.6615C14.5922 18.429 14.898 18.1113 14.879 17.6564C14.8519 17.054 14.2576 16.6801 13.7009 16.6655H13.6606C13.1243 16.6655 12.619 16.9923 12.2884 17.266C11.9582 17.541 11.6045 17.9539 11.3705 18.3416C11.0323 18.9013 10.317 20.3275 11.0186 21.4644C11.3005 21.9194 11.7676 22.1491 12.409 22.1473C12.8575 22.1473 13.3867 22.0319 13.9837 21.8068C14.8768 21.4699 15.5828 21.0067 16.2658 20.5582L16.4497 20.4369C17.1731 19.9641 17.876 19.4139 18.6029 18.7553C20.2069 17.2971 21.1686 15.8713 21.7169 14.128C21.9385 13.4217 22.2527 12.0453 21.86 10.7564Z",
    fill: "#F21016"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAirtelKe);
export default __webpack_public_path__ + "static/media/logoAirtelKE.71f194b28da1152a0b8b6f4da6a8376a.svg";
export { ForwardRef as ReactComponent };